import { getLocaleId, NgIf } from '@angular/common';
import {
	Component,
	Input,
	OnChanges,
	OnInit,
	SimpleChanges,
} from '@angular/core';
import { AccountService } from 'src/app/pages/account/services/account.service';
import { categories } from 'src/app/pages/search/components/search/category-data';
import { Category } from 'src/app/shared/interfaces/category-interface';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatChipsModule } from '@angular/material/chips';

@Component({
    selector: 'app-fundraiser-category',
    templateUrl: './fundraiser-category.component.html',
    styleUrls: ['./fundraiser-category.component.scss'],
    standalone: true,
    imports: [NgIf, MatChipsModule, FlexModule, ExtendedModule]
})
/** *Fundraiser Category Component */
export class FundraiserCategoryComponent implements OnInit, OnChanges {
	@Input() category: any = {};
	//* static category data
	readonly _categories = categories;
	selectedCategories!: Category;
	titleCategory: any;
	currentLocale: any;
	categoryId: number = 1;
	categoryObj: any;

	constructor() {}

	ngOnChanges(changes: SimpleChanges): void {}

	ngOnInit(): void {
		// using the static category id to get data from _categories (localize category name)
		this.categoryId = this.category?.id;
		this.categoryObj = this._categories.find(
			(category) => category.id == this.categoryId
		);
		this.titleCategory = this.categoryObj.name;
	}
}
